import { IParamsToSend } from '@base/@types/providers/Budget/Report'

export const reportRequest: IParamsToSend = {
  empresa: {
    ids: [],
    agrupar: false
  },
  loja: {
    ids: [],
    agrupar: false
  },
  categoriaCompacta: {
    ids: [],
    agrupar: false
  },
  ano: {
    ids: [],
    agrupar: false
  },
  mes: {
    ids: [],
    agrupar: false
  },
  historico: {
    ids: [],
    agrupar: false
  },
  gerenteOperacoes: {
    ids: [],
    agrupar: false
  },
  visualizacao: [],
  dimensao: []
}
